var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40449 9.36687L0 6.24658V12.4871L5.40449 15.6074V9.36687Z",
    fill: "#79C6E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4043 9.36687L10.8088 6.24658V12.4871L5.4043 15.6074V9.36687Z",
    fill: "#79C6E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.809 6.24662L5.40449 9.36693L0 6.24662L5.40449 3.12634L10.809 6.24662Z",
    fill: "#79C6E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6557 12.764C17.6072 12.764 19.9999 10.3713 19.9999 7.41983C19.9999 4.46834 17.6072 2.07568 14.6557 2.07568C11.7042 2.07568 9.31152 4.46834 9.31152 7.41983C9.31152 10.3713 11.7042 12.764 14.6557 12.764Z",
    fill: "#ED718B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1333 17.1235L13.1328 6.24073C12.9413 5.82405 12.3492 5.82405 12.1577 6.24073L7.15723 17.1235C7.15723 18.1181 9.6143 18.9243 12.6452 18.9243C15.6762 18.9243 18.1333 18.1181 18.1333 17.1235Z",
    fill: "#FDA75F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/modules.b2e66424265e6458ec580346f0055e02.svg";
export { ForwardRef as ReactComponent };